module.exports = "{{ text }}"